function getCustomForumLecternItems(matwa, customSectionForumLecternData) {
  if (customSectionForumLecternData[2]) {
    const finalCustomMaterialObj = [];
    const selectedOptions = customSectionForumLecternData[2];
    for (const key in selectedOptions) {
      if (selectedOptions.hasOwnProperty(key)) {
        if (
          selectedOptions[key].RulesKey == "CustomCutOutOptionsId" ||
          selectedOptions[key].RulesKey == "CustomCutOutOptionsFlatPanelId"
        ) {
          matwa.forEach(element => {
            if (element.TranslationCode) {
              if (
                selectedOptions[key].TranslationCode == element.TranslationCode
              ) {
                const splitArr = selectedOptions[key].TranslationCode.split(
                  "~"
                );

                finalCustomMaterialObj.push({
                  matwa: element.PartName,
                  amatnr: splitArr[0],
                  atype: "M",
                  adescription: "Manufacturer",
                  aquantity: 1
                });
                finalCustomMaterialObj.push({
                  matwa: element.PartName,
                  amatnr: splitArr[1]?.slice(0, -2), // removing the last two chars (-Y/-N) because those are used for bom logic in backend
                  atype: "D",
                  adescription: "Model",
                  aquantity: 1
                });
                finalCustomMaterialObj.push({
                  matwa: element.PartName,
                  amatnr: "C",
                  atype: "P",
                  adescription: "Position",
                  aquantity: 1
                });
              }
            }
          });
        }
      }
    }
    return finalCustomMaterialObj;
  }
}

export default {
  getCustomForumLecternItems
};
